import { graphql } from 'gatsby';
import React, { ReactElement } from 'react';
import {
  Body,
  CollectionsCard,
  CollectionsFeatured,
  Headline,
  LibraryTemplate,
} from '../../../components';
import LibraryHead from '../../../components/templates/library/head';

export default function LibraryCollections({ data }): ReactElement {
  return (
    <LibraryTemplate>
      <Headline level="2" className="mb-2">
        Featured Collections
      </Headline>

      <Body className="mb-6">
        Handpicked and curated collections around accessibility.
      </Body>

      <CollectionsFeatured />

      <Headline level="2" className="mt-16 mb-6">
        Browse All Collections
      </Headline>

      <div className="mb-16 grid auto-rows-fr grid-cols-[repeat(auto-fill,261px)] gap-8">
        {data.allStrapiLibraryCollection.nodes.map((node) => (
          <CollectionsCard
            key={node.id}
            title={node.title}
            headerBgColor={node.header.bgColor}
            headerTextColor={node.header.textColor}
            headerIllo={node.header.image.url}
          />
        ))}
      </div>
    </LibraryTemplate>
  );
}

export const pageQuery = graphql`
  query CollectionsPageQuery {
    allStrapiLibraryCollection(sort: { date: DESC }) {
      nodes {
        id
        title
        header {
          bgColor
          textColor
          image {
            url
          }
        }
      }
    }
  }
`;

// Previously inherited head content from the template's nested <Meta>.
// The Head API has no such inheritance, so this has to be explicit.
export const Head = () => <LibraryHead />;
